module.exports = __webpack_public_path__ + "static/lenvima-dose-reduction-desktop-e505758aa539cb8ae64ef58124de8014.png";